import { render, staticRenderFns } from "./IsolationRemainingUsefulLife.vue?vue&type=template&id=2742039d&scoped=true&"
import script from "./IsolationRemainingUsefulLife.vue?vue&type=script&lang=js&"
export * from "./IsolationRemainingUsefulLife.vue?vue&type=script&lang=js&"
import style0 from "./IsolationRemainingUsefulLife.vue?vue&type=style&index=0&id=2742039d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2742039d",
  null
  
)

export default component.exports